import InfiniteScroll from "react-infinite-scroll-component";
import { ProgressSpinner } from "primereact/progressspinner";
import { useCallback, useEffect, useRef, useState } from "react";
import { Checkbox } from "primereact/checkbox";
import { Image } from "primereact/image";

import { getProjectSourceArchive } from "services";
import { useAppDispatch, useAppSelector } from "store/store";
import { SourceRequestInterface } from "interfaces";
import {
  addSources,
  nextPageSources,
  setFirstLoadSources,
  setHasNextPageSources,
  setLoadingSources,
  setSources,
} from "store/slicer/GestioneSourcesSlice";
import {
  InputSearchSources,
  InputSourceTopic,
} from "pages/account/pages/sourcesPage/components";
import { getFileIconByFileType } from "utils";
import { labelTooltipPdf } from "_constants";
import { EmptySourcesList } from "pages/account/pages/detailProjectPage/components";

export const FormAddSourceArchive = ({
  setValue,
  watch,
}: {
  setValue: any;
  watch: any;
}) => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector((state) => state.gestioneSourcesSlice.filters);
  const listSourceArchive = useAppSelector(
    (state) => state.gestioneSourcesSlice.sourcesList
  );
  const hasNextPage = useAppSelector(
    (state) => state.gestioneSourcesSlice.hasNextPage
  );
  const loadingSources = useAppSelector(
    (state) => state.gestioneSourcesSlice.loading
  );
  const firstLoad = useAppSelector(
    (state) => state.gestioneSourcesSlice.firstLoad
  );
  const sourceIdsList = watch("sourceIdsList"); // Mantieni solo gli ID nella lista
  const [hasMore, setHasMore] = useState(true);
  const containerRef = useRef<HTMLDivElement>(null);
  const currentProject = useAppSelector(
    (state) => state.gestioneProjectsSlice.currentProject
  );

  const fetchMoreData = useCallback(() => {
    if (!firstLoad && !loadingSources && hasNextPage) {
      dispatch(nextPageSources());
    }
  }, [dispatch, firstLoad, loadingSources, hasNextPage]);

  const checkLayout = useCallback(() => {
    if (hasNextPage !== undefined) setHasMore(hasNextPage);
    setTimeout(() => {
      if (containerRef.current && hasNextPage) {
        if (containerRef.current?.scrollHeight <= 400) {
          if (!firstLoad && !loadingSources && hasNextPage) {
            dispatch(nextPageSources());
          }
        }
      }
    }, 200);
  }, [dispatch, hasNextPage, firstLoad, loadingSources]);

  useEffect(() => {
    checkLayout();
  }, [checkLayout]);

  useEffect(() => {
    if (filters.pageIndex > -1) {
      dispatch(setLoadingSources(true));
      if (filters.pageIndex === 1) {
        dispatch(setHasNextPageSources(true));
      }
      getProjectSourceArchive(currentProject.id, filters)
        .then((response) => {
          const checkHasNextPage = response.data.totalPages > filters.pageIndex;
          if (filters.pageIndex === 1) {
            dispatch(setSources(response.data.items));
            if (checkHasNextPage) {
              dispatch(nextPageSources());
            } else {
              dispatch(setHasNextPageSources(checkHasNextPage));
            }
          } else {
            dispatch(setHasNextPageSources(checkHasNextPage));
            setHasMore(checkHasNextPage);
            checkLayout();
            dispatch(addSources(response.data.items ?? []));
          }
        })
        .catch((_) => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  useEffect(() => {
    if (!hasNextPage || filters.pageIndex > 1) {
      dispatch(setLoadingSources(false));
      dispatch(setFirstLoadSources(false));
      setHasMore(hasNextPage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasNextPage, filters.pageIndex]);

  const handleCodeChange = (code: SourceRequestInterface) => {
    const isSelected = sourceIdsList.includes(code.id);

    if (isSelected) {
      setValue(
        "sourceIdsList",
        sourceIdsList.filter((id: string) => id !== code.id)
      );
    } else {
      setValue("sourceIdsList", [...sourceIdsList, code.id]);
    }
  };

  return (
    <div className="flex-column">
      <div className="width-100 height-100 margin-top-2">
        <div className="grid-container">
          <div className="width-100">
            <InputSearchSources />
          </div>
          <div className="width-100">
            <InputSourceTopic />
          </div>
        </div>
        <div
          className={`padd-right-10 margin-top-18 ${
            !listSourceArchive?.length ? "empty-codes-list" : ""
          }`}
          id="scroll-sources-div"
          ref={containerRef}
        >
          <InfiniteScroll
            style={{ overflow: "hidden" }}
            dataLength={listSourceArchive?.length ?? 0}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={
              hasMore && (
                <div className="spinner-wrapper">
                  <ProgressSpinner className="custom-spinner" />
                </div>
              )
            }
            scrollableTarget="scroll-sources-div"
          >
            {listSourceArchive?.length
              ? listSourceArchive.map((code) => {
                  return (
                    <div
                      key={code.id}
                      className="flex-container align-center form-add-code relative"
                    >
                      <Checkbox
                        key={code.id}
                        name="code"
                        value={code.id}
                        onChange={() => handleCodeChange(code)}
                        checked={sourceIdsList.includes(code.id)}
                      />
                      <div className="flex-container gap-14 align-center margin-left-28 ">
                        <Image
                          src={getFileIconByFileType(code.fileType)}
                          alt={labelTooltipPdf}
                        />
                        <div>{code.name}</div>
                      </div>
                      <div className="absolute absolute-right-0">
                        <span
                          className={`topic-${code.id} clamp-1 topic-chip`}
                          data-pr-tooltip={code.topic}
                        >
                          {code.topic}
                        </span>
                      </div>
                    </div>
                  );
                })
              : !listSourceArchive?.length &&
                !firstLoad &&
                !loadingSources && <EmptySourcesList />}
          </InfiniteScroll>
        </div>
      </div>
    </div>
  );
};
